import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["current", "target", "difference"]

  connect() {
    this.updateDifference()
  }

  updateDifference() {
    const current = parseFloat(this.currentTarget?.value) || 0
    const target = parseFloat(this.targetTarget?.value) || 0

    if (current > 0 && target > 0) {
      const diff = current - target
      const diffElement = this.differenceTarget

      if (diff > 0) {
        diffElement.innerHTML = `
          <span class="badge px-3 py-2" style="background-color: #D1FAE5; color: #065F46;">
            <i class="bi bi-graph-down-arrow me-1"></i>
            ${diff.toFixed(1)} kg to lose
          </span>
        `
      } else if (diff < 0) {
        diffElement.innerHTML = `
          <span class="badge px-3 py-2" style="background-color: #DBEAFE; color: #1E40AF;">
            <i class="bi bi-graph-up-arrow me-1"></i>
            ${Math.abs(diff).toFixed(1)} kg to gain
          </span>
        `
      } else {
        diffElement.innerHTML = `
          <span class="badge px-3 py-2" style="background-color: #E5E7EB; color: #374151;">
            <i class="bi bi-check-circle me-1"></i>
            Maintain current weight
          </span>
        `
      }
    }
  }

  currentTargetConnected(element) {
    element.addEventListener('input', () => this.updateDifference())
  }

  targetTargetConnected(element) {
    element.addEventListener('input', () => this.updateDifference())
  }
}
